import { ReactElement, forwardRef, useState, useEffect } from 'react';

// import { IconButton } from '@amazing-gaming/components';

import {
  CheckCircleTwoTone as CheckCircleTwoToneIcon,
  CloseTwoTone as CloseTwoToneIcon,
  ErrorTwoTone as ErrorTwoToneIcon,
  InfoTwoTone as InfoTwoToneIcon,
  WarningTwoTone as WarningTwoToneIcon
} from '@mui/icons-material';
import { useTheme, Alert as MUIAlert, AlertTitle, Slide } from '@mui/material';

import _ from 'lodash';

import { TransitionRef, TransitionProps, AlertProps } from './types';

import IconButton from '../../../IconButton';

const Transition = forwardRef<TransitionRef, TransitionProps>(function Transition(props, ref) {
  return <Slide {...props} ref={ref} direction='down' />;
});

export default function Alert(props: AlertProps): ReactElement {
  const theme = useTheme();

  const [title, setTitle] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const { children, open = false, severity = 'info', onClose } = props;

  useEffect(() => {
    const string = children?.toString() || '';
    const title = string.substring(0, string.indexOf('|'));
    const message = string.substring(string.indexOf('|') + 1);

    setTitle(title.trim() || _.upperCase(severity));
    setMessage(message.trim() || '');
  }, [children]);

  return (
    <Transition in={open} timeout={theme.transitions.duration.standard}>
      <MUIAlert
        action={
          <IconButton aria-label='Alert Close Button' onClick={() => onClose()} variant='icon'>
            <CloseTwoToneIcon />
          </IconButton>
        }
        color={severity}
        iconMapping={{
          error: <ErrorTwoToneIcon />,
          info: <InfoTwoToneIcon />,
          success: <CheckCircleTwoToneIcon />,
          warning: <WarningTwoToneIcon />
        }}
        onClose={() => onClose()}
        severity={severity || 'info'}
        variant='filled'>
        <AlertTitle>{title}</AlertTitle>
        {message}
      </MUIAlert>
    </Transition>
  );
}
